import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';
import { handleApiError } from '../../requestHelpers/requestHelpers';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';

export const useChangePayment = () => {
  const { t } = useTranslation();

  return useMutation<ApiResponse<any>, ApiError<null>>(
    () => dataFetch.get(
      `${DIGGER_API_SUFFIX}organizations/update-payment-method`,
    ),
    {
      onSuccess: (response) => {
        closableEnqueueSnackbar(t('acceptedRequest'), 'success');
        window.location.replace(response?.data?.data?.data.checkout.url);
      },
      onError: (error: any) => {
        handleApiError(error, t);
      },
    },
  );
};
